import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CertificateModalOne from "./CertificateModalOne";
import CertificateModalTwo from "./CertificateModalTwo";
import { faFacebookF, faInstagram, faLinkedinIn, faYoutube, } from "@fortawesome/free-brands-svg-icons";
// import ClutchWidget from "../../ClutchWidget";

const Footer = ({ isIndia = true }) => {
  const [lgShow, setLgShow] = useState(false);
  const [lgTwoShow, setLgTwoShow] = useState(false);
  const [footerLoad, setFooterLoad] = useState(false)

  useEffect(() => {
    if (footerLoad) {
      const scriptId = "good-firms-widget-script";

      const existingScript = document.getElementById(scriptId);
      if (existingScript) {
        existingScript.remove();
      }

      const script = document.createElement("script");
      script.id = scriptId;
      script.src = "https://assets.goodfirms.co/assets/js/widget.min.js";
      script.async = true;
      script.onload = () => {

        if (window.GOODFIRMS && typeof window.GOODFIRMS.Init === "function") {
          window.GOODFIRMS.Init();
        }
      };
      document.body.appendChild(script);
    }
  }, [footerLoad]);

  useEffect(() => {
    if (footerLoad) {
      const botScriptId = "messenger-widget-b";
      const existingScript = document.getElementById(botScriptId);

      if (!existingScript) {
        const script = document.createElement("script");
        script.id = botScriptId;
        script.src = "https://cdn.botpenguin.com/website-bot.js";
        script.defer = true;
        script.innerHTML = "67e69fdb1319143d3ce40a04,67e69f485e9baf2f1bca5158";
        document.body.appendChild(script);
      }
    }
  }, [footerLoad]);

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setFooterLoad(true)
  //   }, 600);
  //   return () => clearTimeout(timer);
  // }, [])

  useEffect(() => {
    const handleScroll = () => {
      if (!footerLoad && window.scrollY > 0) { // Trigger only on first scroll
        setFooterLoad(true);
        window.removeEventListener("scroll", handleScroll); // Remove event listener after triggering
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll); // Cleanup event listener
  }, [footerLoad]);

  if (!footerLoad) {
    return null;
  }

  return (
    <>
      <CertificateModalOne lgShow={lgShow} setLgShow={setLgShow} />
      <CertificateModalTwo lgTwoShow={lgTwoShow} setLgTwoShow={setLgTwoShow} />

      <footer className="footer">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-4">
              <div className="footer-logo">
                <img src="/assets/Logo1.webp" alt="Logo" loading="lazy" />
                <p>Empowering Future Mobility with Innovation.</p>
                <br />
                <div className="footer-links footer-gradiant-links">
                  <h2>CERTIFICATES</h2>
                  <div className="certifications-logos">
                    <span onClick={() => setLgShow(true)}>
                      <img loading="lazy" src="/assets/home/ISO-2022.webp" alt="certificate" />
                    </span>
                    <span onClick={() => setLgTwoShow(true)}>
                      <img loading="lazy" src="/assets/home/ISO-2015.webp" alt="certificate" />
                    </span>
                  </div>

                  <h3 className="email-vector-wrap"> <img className="img-responsive" src="/assets/home/email-us.webp" alt="email" loading="lazy" /> Email Us:</h3>
                  <ul className="footer-gradiant-links">
                    <li>
                      <Link onClick={(e) => { window.location.href = "mailto:sales@mobilityinfotech.com"; e.preventDefault(); }}> sales@mobilityinfotech.com</Link>
                    </li>
                  </ul>
                </div>
              </div>

              {/* <div className="footer-app">
                <div>
                  <Link to={""}>
                    <img src="./assets/home/app-store.png" alt="app store" />
                  </Link>
                  <Link to={""}>
                    <img
                      src="./assets/home/google-play.png"
                      alt="google play"
                    />
                  </Link>
                </div> */}
              {/* <div>
                              <span className="gradiant-color">Download the App</span>
                              <img src="./assets/home/qr-code.png" alt="qr code"/>
                          </div> */}
              {/* </div> */}
            </div>

            <div className="col-lg-8 col-md-8">
              <div className="row">
                <div className="col-lg-4 col-md-4 col-6">
                  <div className="footer-links">
                    <h2>Quick Links</h2>
                    <ul>
                      <li>
                        <Link to={"/about"}>About Us</Link>
                      </li>
                      <li>
                        <Link to={"/best-taxi-dispatch-software"}>Taxi Software</Link>
                      </li>
                      <li>
                        <Link to={"/pricing"}>Pricing</Link>
                      </li>
                      <li>
                        <Link to={"/blog"}>Our Blogs</Link>
                      </li>
                      <li>
                        <Link to={"/contact"}>Contact Us</Link>
                      </li>
                      <li>
                        <Link to={"/media"}>Media</Link>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="col-lg-4 col-md-4 col-6">
                  <div className="footer-links">
                    <h2>Products</h2>
                    <ul>
                      <li>
                        <Link to={"/white-label-solutions"}>White Label Software</Link>
                      </li>
                      <li>
                        <Link to={"/custom-app-development"}>Custom App</Link>
                      </li>
                      <li>
                        <Link to={"/shuttle-software"}>Shuttle Software</Link>
                      </li>
                      <li>
                        <Link to={"/white-lable-carpool-app-dispatch-software"}>Carpool App</Link>
                      </li>
                      <li>
                        <Link to={""}>Clone App</Link>
                      </li>
                      <li>
                        <Link to={"/clone-app/lyft-clone-app"}>Lyft Clone App</Link>
                      </li>
                      <li>
                        <Link to={"/clone-app/uber-clone-app"}>Uber Clone App</Link>
                      </li>
                    </ul>
                  </div>
                </div>
                {isIndia ? (
                  <div className="col-lg-4 col-md-4 col-12">
                    <div className="footer-links">
                      <h2>India Address:</h2>
                      <p> DLF Phase 2, Sector 25, Gurugram, Haryana, India 122022</p>

                      <h3>Taiwan Address:</h3>
                      <p> 16F, No. 19, Alley 31, Lane 743, Section 5, Zhongxiao East Road, Xinyi District, Taipei City, Taiwan</p>

                      <h3>US Address:</h3>
                      <p>16192 Coastal Highway, Lewes, Delaware 19958, County of Sussex</p>

                      <h3>Italy Address:</h3>
                      <p>Viale D’Agostino 51, Imola (BO) 40026</p>
                    </div>
                  </div>
                ) : (
                  <div className="col-lg-4 col-md-4 col-12">
                    <div className="footer-links">
                      <h2>Taiwan Address:</h2>
                      <p> 16F, No. 19, Alley 31, Lane 743, Section 5, Zhongxiao East Road, Xinyi District, Taipei City, Taiwan</p>

                      <h3>US Address:</h3>
                      <p>16192 Coastal Highway, Lewes, Delaware 19958, County of Sussex</p>

                      <h3>Italy Address:</h3>
                      <p>Viale D’Agostino 51, Imola (BO) 40026</p>

                      <h3>India Address:</h3>
                      <p> DLF Phase 2, Sector 25, Gurugram, Haryana, India 122022</p>
                    </div>
                  </div>
                )}

              </div>
            </div>

            <div className="col-lg-12">
              <div className="row justify-content-center align-items-center">
                <div className="col-lg-5 col-md-6 col-xl-4">
                  <div className="goodfirm-widget-wrapper">
                    <div className="goodfirm-widget" data-widget-type="goodfirms-widget-t3" data-widget-pattern="star-basic" data-height="100" data-company-id="161173"></div>
                  </div>
                  {/* <ClutchWidget/> */}

                </div>

                <div className="col-lg-7 col-xl-8">
                  <div className="footer-companies">
                    <span><a target="_blank" href="https://www.g2.com/products/mobility-infotech/reviews#reviews"><img loading="lazy" src="/assets/home/footer-company-11.webp" alt="company" className="img-responsive" /></a></span>
                    <span><a target="_blank" href="https://clutch.co/profile/mobility-infotech"><img loading="lazy" src="/assets/home/footer-company-5.webp" alt="company" className="img-responsive" /></a></span>
                    <span><img loading="lazy" src="/assets/home/footer-company-9.webp" alt="company" className="img-responsive" /></span>
                    <span><img loading="lazy" src="/assets/home/footer-company-1.webp" alt="company" className="img-responsive" /></span>
                    <span><img loading="lazy" src="/assets/home/footer-company-2.webp" alt="company" className="img-responsive" /></span>
                    {/* <span><img loading="lazy" src="/assets/home/footer-company-3.webp" alt="company" className="img-responsive" /></span> */}
                    <span><img loading="lazy" src="/assets/home/footer-company-4.webp" alt="company" className="img-responsive" /></span>
                    <span><img loading="lazy" src="/assets/home/footer-company-6.webp" alt="company" className="img-responsive" /></span>
                    <span><img loading="lazy" src="/assets/home/footer-company-7.webp" alt="company" className="img-responsive" /></span>
                    <span><img loading="lazy" src="/assets/home/footer-company-8.webp" alt="company" className="img-responsive" /></span>
                    <span><img loading="lazy" src="/assets/home/footer-company-10.webp" alt="company" className="img-responsive" /></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row footer-copyright align-items-center">
            <div className="col-lg-4 col-sm-6 col-md-6 col-6 order-1 order-lg-1 order-md-1 order-sm-1">
              {/* <p className="footer-country">
                INDIA - TAIWAN - USA - UNITED KINGDOM{" "}
              </p> */}
              <div className="footer-country-wrap">
                <div>
                  <img src="/assets/home/footer-country-3.webp" alt="country" className="img-responsive" loading="lazy" />
                </div>
                <div>
                  <img src="/assets/home/footer-country-4.webp" alt="country" className="img-responsive" loading="lazy" />
                </div>
                <div>
                  <img src="/assets/home/footer-country-2.webp" alt="country" className="img-responsive" loading="lazy" />
                </div>
                <div>
                  <img src="/assets/home/footer-country-1.webp" alt="country" className="img-responsive" loading="lazy" />
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-sm-6 col-md-6 col-6 order-2 order-lg-2 order-md-2 order-sm-2">
              <ul className="footer-social">
                <li>
                  <Link to={"https://www.facebook.com/profile.php?id=61565074738395"} target="_blank" aria-label="Visit our Facebook profile"> <FontAwesomeIcon icon={faFacebookF} /> </Link>
                </li>
                <li>
                  <Link to={"https://www.instagram.com/mobility_infotech/"} target="_blank" aria-label="Visit our Instagram profile"><FontAwesomeIcon icon={faInstagram} /></Link>
                </li>
                <li>
                  <Link to={"https://www.linkedin.com/company/mobility-infotech-pvt-ltd/"} target="_blank" aria-label="Visit our LinkedIn profile"><FontAwesomeIcon icon={faLinkedinIn} /></Link>
                </li>
                <li>
                  <Link to={"https://www.youtube.com/@MobilityInfotech"} target="_blank" aria-label="Visit our YouTube channel"><FontAwesomeIcon icon={faYoutube} /></Link>
                </li>
              </ul>
            </div>

            <div className="col-lg-4 col-sm-12 col-md-12 col-12 order-3 order-lg-3 order-md-3 order-sm-3 text-right">
              <div className="footer-policy-box">
                <Link to="/privacy-policy?tab=privacy" className="footer-privacy">Privacy Policy</Link>
                <Link to="/privacy-policy?tab=conditions" className="footer-privacy">TERM & CONDITION</Link>
                <Link to={"/privacy-policy?tab=cookies"} className="footer-privacy">COOKIES POLICY</Link>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;